import { At802Plane } from "./At802Plane";
import { PineTree } from "./PineTree";
import "./ErrorScoopAnimation.css";
import "./scoop-animation-shared.css";

function ErrorScoopAnimation() {
  return (
    <div className="scoop-scene error-scoop-scene" aria-hidden="true">
      <svg
        className="scoop-svg error-scoop-svg"
        viewBox="0 0 96 48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="hills-back">
          <rect className="hill-far" height="18" width="30" x="0" y="30" />
          <rect className="hill-far" height="20" width="26" x="18" y="28" />
          <rect className="hill-far" height="17" width="32" x="40" y="31" />
          <rect className="hill-far" height="19" width="30" x="66" y="29" />
        </g>

        <g className="pine-grove-back">
          <PineTree baseX={6} baseY={31} variant="back" />
          <PineTree baseX={16} baseY={30} variant="back" />
          <PineTree baseX={28} baseY={31} variant="back" />
          <PineTree baseX={48} baseY={30} variant="back" />
          <PineTree baseX={60} baseY={31} variant="back" />
          <PineTree baseX={74} baseY={30} variant="back" />
          <PineTree baseX={86} baseY={31} variant="back" />
        </g>

        <g className="hills-mid">
          <rect className="hill-mid" height="14" width="38" x="0" y="34" />
          <rect className="hill-mid" height="16" width="42" x="28" y="32" />
          <rect className="hill-mid" height="14" width="36" x="60" y="34" />
        </g>

        <g className="pine-grove-mid">
          <PineTree baseX={10} baseY={35} variant="back" />
          <PineTree baseX={38} baseY={34} variant="back" />
          <PineTree baseX={68} baseY={35} variant="back" />
        </g>

        <rect className="forest-ground" height="8" width="96" x="0" y="40" />

        <g className="pine-grove-fore">
          <PineTree baseX={4} baseY={40} />
          <PineTree baseX={18} baseY={40} />
          <PineTree baseX={30} baseY={40} />
          <PineTree baseX={52} baseY={40} />
          <PineTree baseX={70} baseY={40} />
          <PineTree baseX={84} baseY={40} />
        </g>

        <g className="forest-fire">
          <rect className="fire-core" height="2" width="3" x="20" y="38" />
          <rect className="fire-core" height="2" width="4" x="32" y="37" />
          <rect className="fire-core" height="3" width="5" x="33" y="38" />
          <rect className="fire-flame" height="2" width="3" x="44" y="38" />
          <rect className="fire-flame" height="2" width="4" x="64" y="37" />
          <rect className="fire-core" height="2" width="3" x="76" y="38" />
          <rect className="fire-flame" height="1" width="2" x="21" y="36" />
          <rect className="fire-flame" height="1" width="2" x="45" y="36" />
          <rect className="fire-flame" height="1" width="2" x="65" y="36" />
        </g>

        <g className="forest-smoke">
          <rect className="smoke-puff" height="1" width="2" x="33" y="24" />
          <rect className="smoke-puff" height="1" width="3" x="34" y="22" />
          <rect className="smoke-puff" height="1" width="2" x="44" y="26" />
          <rect className="smoke-puff" height="1" width="3" x="64" y="23" />
          <rect className="smoke-puff" height="1" width="2" x="65" y="21" />
          <rect className="smoke-puff" height="1" width="2" x="76" y="25" />
        </g>

        <g className="water-drop">
          <rect height="1" width="2" x="20" y="18" />
          <rect height="2" width="2" x="22" y="20" />
          <rect height="2" width="2" x="24" y="22" />
          <rect height="2" width="2" x="26" y="24" />
          <rect height="2" width="2" x="28" y="26" />
          <rect height="2" width="2" x="30" y="28" />
          <rect height="2" width="2" x="32" y="30" />
          <rect height="2" width="2" x="34" y="32" />
          <rect height="2" width="2" x="36" y="34" />
        </g>

        <g className="water-burst">
          <rect height="1" width="2" x="30" y="36" />
          <rect height="2" width="2" x="32" y="35" />
          <rect height="2" width="3" x="34" y="34" />
          <rect height="1" width="2" x="38" y="36" />
          <rect height="2" width="2" x="40" y="35" />
          <rect height="1" width="2" x="42" y="37" />
          <rect height="1" width="2" x="62" y="36" />
          <rect height="2" width="2" x="64" y="35" />
          <rect height="1" width="2" x="66" y="37" />
        </g>

        <At802Plane />
      </svg>
    </div>
  );
}

export { ErrorScoopAnimation };
